/**
 * config.ts - App configuration and shared mutable state.
 *
 * `state` is intentionally a single mutable object imported by reference
 * across modules, mirroring the original script's behavior. If this grows
 * further, consider a small pub/sub or moving to a framework's state
 * management instead of a shared mutable singleton.
 */

export interface State {
    currentStep: number;
    playersCount: number;
    donationAmount: number;
    paymentMethod: string;
}

export const CONFIG = {
    baseEntryFee: 40.00,
    uscfLookupApiUrl: '/api/uscf/lookup',
    uscfSearchApiUrl: '/api/players/search',
    submitRegistrationUrl: '/register/submit',
    registerInitUrl: '/register/init',
};

export const state: State = {
    currentStep: 1,
    playersCount: 0,
    donationAmount: 0.00,
    paymentMethod: 'Online'
};